"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../../utils/documents");

var _arrays = require("../../../utils/arrays");

var _ThreeDotsMenu = _interopRequireDefault(require("../../ThreeDotsMenu"));

var _MenuCommand = _interopRequireDefault(require("../../MenuCommand"));

var _jsxRuntime = require("react/jsx-runtime");

function DocumentVersionMenuActions(props) {
  var actions = [];

  if (props.documentPermissions.canEditAdditionalDesignation) {
    actions.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuCommand.default, {
      id: "document-menu-actions-additional-designation",
      onClick: function onClick() {
        return props.documentActions.onEditAdditionalDesignation(props.document);
      },
      label: document.additionalDesignation ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.editAdditionalDesignation"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.addAdditionalDesignation"
      }),
      icon: "info"
    }));
  }

  if (props.documentPermissions.canDuplicate && (0, _documents.isMultiOccurrence)(props.document)) {
    actions.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuCommand.default, {
      id: "document-menu-actions-duplicate",
      onClick: function onClick() {
        return props.documentActions.onDuplicate(props.document);
      },
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.duplicate"
      }),
      icon: "document-page"
    }));
  }

  if ((0, _documents.canBeDeleted)(props.document, props.documentPermissions)) {
    actions.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuCommand.default, {
      id: "document-menu-actions-delete",
      onClick: function onClick() {
        return props.documentActions.onDelete(props.document);
      },
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.delete"
      }),
      icon: "trash"
    }));
  }

  if ((0, _arrays.isEmpty)(actions)) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThreeDotsMenu.default, {
    children: actions.map(function (action, key) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: action
      }, key);
    })
  });
}

DocumentVersionMenuActions.propTypes = {
  document: (0, _documents.documentVersionPropTypes)().isRequired,
  documentPermissions: (0, _documents.documentPermissionsPropTypes)().isRequired,
  documentActions: (0, _documents.documentActionsPropTypes)().isRequired
};
var _default = DocumentVersionMenuActions;
exports.default = _default;
//# sourceMappingURL=DocumentVersionMenuActions.js.map